'use strict';
var escalationIssueTrackingModalTpl = require('../../escalation/issueTrackingModal.html');
var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$scope", "$rootScope", "$filter", "$uibModal", "ProjectService", "ZabbixOverviewFactory", "InvestigateStateChangeFactory", "MonitoringStoreService", function AlarmsMonitoringViewController(
    $scope,
    $rootScope,
    $filter,
    $uibModal,
    ProjectService,
    ZabbixOverviewFactory,
    InvestigateStateChangeFactory,
    MonitoringStoreService) {

    var vm = this;
    var name = "alarms";

    vm.unAcknowledgedAlarmsCount = 0;
    vm.acknowledgedAlarmsCount = 0;
    vm.highSeverityAlarms = 0;
    vm.mediumSeverityAlarms = 0;
    vm.warningAlarms = 0;
    vm.dataReady = false;

    // all current issues = custom issues + zabbix issues
    var currentIssues = [];

    // variable for holding alarms to send to child component 'alarm-list'
    vm.alarms;

    // variable for holding filtered alarms
    vm.filteredAlarms;

    vm.trainConfigData;

    // selectedFilterDetails is used to keep track of selected filter,
    // which is used to manage style accordingly
    vm.selectedFilterDetails;

    var deRegisterTrainsUpdatedListener = $rootScope.$on('trains-updated', function(){
        getData();
    });

    var defaultTileClasses = {
        unacknowledged: "danger-tile text-center",
        highSeverity: "high-severity-tile text-center",
        mediumSeverity: "medium-severity-tile text-center",
        warningSeverity: "low-severity-tile text-center",
        acknowledged: "acknowledged-tile text-center"
    };

    vm.tileClasses = Object.assign({}, defaultTileClasses);

    vm.unselectedTileClass = "neutral-tile text-center";
    vm.defaultTileCss = "default";

    var selectedFilters = [];

    init();

    vm.onAlarmLeftClick = function(alarm) {
        InvestigateStateChangeFactory.investigateInDetail({ trainId: alarm.trainId, projectId: alarm.projectId });
    };

    vm.onRaiseIncidentClick = function(alarm) {

        alarm["fleet"] = (vm.trainConfigData ? vm.trainConfigData[alarm.trainId] : undefined);

        var issueTrackingModal = $uibModal.open({
            template: escalationIssueTrackingModalTpl,
            controller: 'IssueTrackingModalController',
            controllerAs: 'vm',
            keyboard: true,
            animation: true,
            resolve: {
                issue: alarm
            }
        });

        // on modal close/dismiss
        issueTrackingModal.result.then(function (data) {  // Success - on modal close()

            if (util.isTrue(data.success)) {

                // if the issue hasn't been acknowledged yet, fire the ack request!
                if (!alarm.acknowledged) {
                    var eventIds = [];
                    eventIds.push(alarm.eventId);

                    // zabbix-alarm or noc-alarm
                    if (util.isDefined(alarm.type)) {

                        ZabbixOverviewFactory.postAcknowledgement(ProjectService.getSelectedProjectId(), alarm.trainId, eventIds, alarm.type).then(function () {
                            MonitoringStoreService.updateTrainAlarms(alarm.trainId, alarm);
                        });
                    }
                }

                // updating incidentId in alarm List 
                alarm.incidentId = data.incidentId;
            }
        }, function() { /** Cancel - on modal dismiss() */ });

    };
 
    function calculateStats() {

        vm.unAcknowledgedAlarmsCount = currentIssues.reduce(function (total, issue) {
            total = total + (issue.acknowledged ? 0 : 1);
            return total;
        }, 0);
        vm.acknowledgedAlarmsCount = currentIssues.reduce(function (total, issue) {
            total = total + (issue.acknowledged ? 1 : 0);
            return total;
        }, 0);
        vm.highSeverityAlarms = severityCountForCurrentIssues(4);
        vm.mediumSeverityAlarms = severityCountForCurrentIssues(3);
        vm.warningAlarms = severityCountForCurrentIssues(2);
    }

    function getData() {
        currentIssues = MonitoringStoreService.getAlarms(ProjectService.getSelectedProjectId());
        vm.dataReady = true;
        calculateStats();
        vm.alarms = vm.filteredAlarms = filterAlarms(currentIssues, vm.selectedFilterDetails.filterObj);
        vm.trainConfigData = {};
        MonitoringStoreService.getTrains(ProjectService.getSelectedProjectId()).forEach(function (train){
            vm.trainConfigData[train.trainId] = train.trainType;
        });
    }

    /**
     * Count the number of current issues (visible in the table) that have the given severity
     *
     * @param severity
     * @returns {number}
     */
    function severityCountForCurrentIssues(severity) {
        return currentIssues.reduce(function (count, issue) {
            count += (!issue.acknowledged && issue.severity && issue.severity === severity) ? 1 : 0;
            return count;
        }, 0);
    }

    function init() {
        $scope.$emit('init-child', name);

        vm.selectedFilterDetails = { filterObj: { 'acknowledged': false }, filterApplied: true };
        updateTileStyle('unacknowledged');

        getData();
    }

    function filterAlarms(alarmsArray, filterObj) {

        return alarmsArray.filter(function (alarmObj, index, arr) {
            var recordMatch = false;
            var allKeysMatch = true;

            for (const key of Object.keys(filterObj)) {

                if (alarmObj[key] === filterObj[key]) {
                    recordMatch = allKeysMatch && true;
                } else {
                    allKeysMatch = false;
                    recordMatch = false;
                }
            }

            return recordMatch;
        }, this);
    }

    vm.onTileClick = function (cssClsName, filterObj) {

        if (vm.selectedFilterDetails) {

            if (isEquivalent(vm.selectedFilterDetails.filterObj, filterObj)) {

                if (vm.selectedFilterDetails.filterApplied) { // remove filter

                    // apply all tiles default style
                    updateTileStyle(vm.defaultTileCss);

                    vm.alarms = currentIssues;
                    vm.selectedFilterDetails.filterApplied = false;

                } else {

                    // highlight clicked tile, deselect other tiles
                    updateTileStyle(cssClsName);

                    vm.alarms = vm.filteredAlarms;
                    vm.selectedFilterDetails.filterApplied = true;
                }

            } else {
                // highlight clicked tile, deselect other tiles
                updateTileStyle(cssClsName);

                // Filter alarms
                if (currentIssues.length > 0) {
                    vm.alarms = vm.filteredAlarms = filterAlarms(currentIssues, filterObj);
                    
                    vm.selectedFilterDetails.filterObj = filterObj;
                    vm.selectedFilterDetails.filterApplied = true;
                }
            }
        }
    };

    function updateTileStyle(cssClsName) {

        if (cssClsName === vm.defaultTileCss) {

            // no filters selected, give all the tiles their default class (colour)    
            for (const key of Object.keys(vm.tileClasses)) {
                vm.tileClasses[key] = angular.copy(defaultTileClasses[key]);
            }
        } else {

            for (const key of Object.keys(vm.tileClasses)) {
                if (key === cssClsName) {
                    vm.tileClasses[key] = angular.copy(defaultTileClasses[key]);
                } else {
                    vm.tileClasses[key] = vm.unselectedTileClass;
                }
            }
        }
    }

    /** Compare two objects if they are equal i.e. have same property names and their values */
    function isEquivalent(obj1, obj2) {

        if ((obj1 instanceof Object && !(obj1 instanceof Array))
            && (obj2 instanceof Object && !(obj2 instanceof Array))) {

            // Create arrays of property names
            var obj1Props = Object.getOwnPropertyNames(obj1);
            var obj2Props = Object.getOwnPropertyNames(obj2);

            // If number of properties is different, objects are not equivalent
            if (obj1Props.length != obj2Props.length) {
                return false;
            }

            for (var i = 0; i < obj1Props.length; i++) {
                var propName = obj1Props[i];

                // If values of same property are not equal, objects are not equivalent
                if (obj1[propName] !== obj2[propName]) {
                    return false;
                }
            }

            return true;
        }

        return false;
    }

    $scope.$on('$destroy', function () {
        console.log("destrying alarms")
        deRegisterTrainsUpdatedListener();
        // all current issues = custom issues + zabbix issues
        currentIssues = [];
        vm.alarms = undefined;
        vm.filteredAlarms = undefined;
        vm.trainConfigData = undefined;
        vm.selectedFilterDetails = undefined;
    });

}];
